<script setup>
import { useSupplierSessionStore } from '@supplier/stores/useSupplierSessionStore'
import { useI18n } from 'vue-i18n'

import { useSupplierImpersonation } from '@supplier/layouts/composables/useSupplierImpersonation'

import AppButton from '@ui/app-button/AppButton.vue'

const { t } = useI18n()
const session = useSupplierSessionStore()
const { isImpersonating, isLeaving, leaveImpersonation } = useSupplierImpersonation()
</script>

<template>
  <div
    v-if="isImpersonating"
    class="supplier-impersonation-banner"
  >
    <span class="supplier-impersonation-banner-text font-medium-body">
      {{ t('ui.supplier_portal.impersonation.logged_in_as') }}
      <b class="supplier-impersonation-banner-name">{{ session.displayName }}</b>
    </span>
    <app-button
      variant="text"
      size="xs"
      :loading="isLeaving"
      data-element="supplier-impersonation-logout-btn"
      @click="leaveImpersonation"
    >
      {{ t('ui.supplier_portal.impersonation.logout') }}
    </app-button>
  </div>
</template>

<style lang="scss" scoped>
.supplier-impersonation-banner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 36px;
  padding: 0 20px;
  gap: 12px;
  background-color: var(--s-yellow);
  color: var(--s-yellow-dark);

  &-name {
    font-weight: 600;
  }
}
</style>
